// frontend/src/components/AuthPage.js

import React, { useState } from 'react';
import {
  Box, Typography, TextField, Button,
  Paper, Divider, Alert
} from '@mui/material';
import api from '../api';
import { useNavigate } from 'react-router-dom';

const AuthPage = ({ setAuth }) => {
  const navigate = useNavigate();

  // Sign-in state
  const [signInEmail, setSignInEmail] = useState('');
  const [signInPassword, setSignInPassword] = useState('');
  const [signinError, setSigninError] = useState('');

  // Sign-up state
  const [name, setName]               = useState('');
  const [email, setEmail]             = useState('');
  const [password, setPassword]       = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [signupError, setSignupError] = useState('');
  const [signupSuccess, setSignupSuccess] = useState('');

  const handleSignIn = async () => {
    setSigninError('');
    try {
      const res = await api.post('/signin', {
        email: signInEmail,
        password: signInPassword,
      });
      if (res.data?.msg === 'Signin successful') {
        setAuth(true);
        localStorage.setItem('authenticated','true');
        localStorage.setItem('userEmail', signInEmail);
        navigate('/');
      } else {
        setSigninError(res.data?.msg || 'Signin failed');
      }
    } catch (err) {
      setSigninError(err.response?.data?.msg || 'Server error');
    }
  };

  const handleSignUp = async () => {
    setSignupError('');
    setSignupSuccess('');

    if (password !== confirmPassword) {
      setSignupError('Passwords do not match!');
      return;
    }
    if (password.length < 8) {
      setSignupError('Password must be at least 8 characters long.');
      return;
    }
    const pwdRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])/;
    if (!pwdRegex.test(password)) {
      setSignupError('Password must include at least one number and one special character.');
      return;
    }

    try {
      const res = await api.post('/signup', {
        name,
        email,
        password
      });
      if (res.data?.msg === 'Signup successful') {
        setSignupSuccess('Signup successful! Please login.');
        setName(''); setEmail(''); setPassword(''); setConfirmPassword('');
      } else {
        setSignupError(res.data?.msg || 'Signup failed');
      }
    } catch (err) {
      setSignupError(err.response?.data?.msg || 'Server error');
    }
  };

  return (
    <Box sx={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      height: '100vh', bgcolor: '#f4f4f4', p: { xs: 2, sm: 4 }
    }}>
      <Paper elevation={3} sx={{
        width: '100%', maxWidth: { xs: '90%', md: 900 },
        display: 'flex', flexDirection: { xs: 'column', md: 'row' },
        borderRadius: 3, overflow: 'hidden'
      }}>
        {/* Sign In */}
        <Box sx={{ flex: 1, p: 3 }}>
          <Typography variant="h4" gutterBottom>Sign In</Typography>
          {signinError && <Alert severity="error" sx={{ mb: 2 }}>{signinError}</Alert>}
          <TextField
            label="Email" fullWidth sx={{ mb: 2 }}
            value={signInEmail}
            onChange={e => setSignInEmail(e.target.value)}
          />
          <TextField
            label="Password" type="password" fullWidth sx={{ mb: 2 }}
            value={signInPassword}
            onChange={e => setSignInPassword(e.target.value)}
          />
          <Button variant="contained" fullWidth onClick={handleSignIn}>
            Login
          </Button>
        </Box>

        <Divider orientation={{ xs: 'horizontal', md: 'vertical' }}
                 flexItem sx={{ bgcolor: '#aaa', mx: { md: 2 }, my: { xs: 1, md: 4 } }}/>

        {/* Sign Up */}
        <Box sx={{ flex: 1, p: 3, bgcolor: '#fafafa' }}>
          <Typography variant="h4" gutterBottom>Create an Account</Typography>
          {signupError   && <Alert severity="error"   sx={{ mb: 2 }}>{signupError}</Alert>}
          {signupSuccess && <Alert severity="success" sx={{ mb: 2 }}>{signupSuccess}</Alert>}
          <TextField
            label="Name" fullWidth sx={{ mb: 2 }}
            value={name} onChange={e => setName(e.target.value)}
          />
          <TextField
            label="Email" type="email" fullWidth sx={{ mb: 2 }}
            value={email} onChange={e => setEmail(e.target.value)}
          />
          <TextField
            label="Password" type="password" fullWidth sx={{ mb: 2 }}
            value={password} onChange={e => setPassword(e.target.value)}
          />
          <TextField
            label="Confirm Password" type="password" fullWidth sx={{ mb: 2 }}
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
          />
          <Button variant="contained" fullWidth onClick={handleSignUp}>
            Sign Up
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AuthPage;
